module.exports = __webpack_public_path__ + "img/personal-center-bg-pc.d527564.png";